/**
 * Il medico di una visita come si scrive a schermo.
 *
 * STILE NUOVO («Console»): «Dott.ssa Rossi Anna». Il titolo e' quello della
 * scheda del medico (medici.titolo), che le query delle visite portano come
 * `medico_titolo` dal 6/10/2026 (anche nella forma ridotta di una riservata).
 * Fino a quel giorno la cartella scriveva «Dr.» davanti a ogni medico, in
 * quattro punti scritti a mano: le due «Dott.ssa» diventavano «Dr.»
 * (revisione della cartella dello stile «Console»). Senza titolo resta
 * «Dr.». Senza medico: stringa vuota, e chi chiama decide che cosa scrivere.
 *
 * STILE DI PRIMA (interruttore spento): «Dr.» davanti a tutti, com'era, per
 * costruzione identico a 638a8209. Lo stile lo decide l'utente di adesso
 * (navigazione/paginaIniziale), non una copia della regola: i quattro punti
 * che chiamano questa funzione sono componenti condivisi fra i due stili.
 */
import { useAuthStore } from '../store/useStore';
import { stileNuovo } from '../navigazione/paginaIniziale';

export const medicoDellaVisita = (v) => {
    if (!stileNuovo(useAuthStore.getState().user)) {
        /* Com'era scritto nei componenti: «Dr. » e i due valori, anche vuoti. */
        return `Dr. ${v?.medico_cognome ?? ''} ${v?.medico_nome ?? ''}`;
    }
    const cognome = String(v?.medico_cognome || '').trim();
    if (!cognome) return '';
    const titolo = String(v.medico_titolo || '').trim() || 'Dr.';
    const nome = String(v.medico_nome || '').trim();
    return [titolo, cognome, nome].filter(Boolean).join(' ');
};

export default medicoDellaVisita;
